export const FEATURE_NAME = "reports";
